import { render, staticRenderFns } from "./ObjectDangerOccurStatisticBar2.vue?vue&type=template&id=1242ee0a&"
import script from "./ObjectDangerOccurStatisticBar2.vue?vue&type=script&lang=js&"
export * from "./ObjectDangerOccurStatisticBar2.vue?vue&type=script&lang=js&"
import style0 from "./ObjectDangerOccurStatisticBar2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/aikl_dev/Projects/v2/kcc/aikl_v2_front_kcc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1242ee0a')) {
      api.createRecord('1242ee0a', component.options)
    } else {
      api.reload('1242ee0a', component.options)
    }
    module.hot.accept("./ObjectDangerOccurStatisticBar2.vue?vue&type=template&id=1242ee0a&", function () {
      api.rerender('1242ee0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/biz/ObjectDangerOccurStatisticBar2.vue"
export default component.exports